export class UnreachableSwitchError extends Error {
    constructor(message: string = 'Never expected to get this far.') {
        super(message);
    }

    errorMessage(value: any): string {
        return `${this.message}. With a value: ${value}`;
    }
}
